export default __webpack_public_path__ + "static/awsoffice-d243d8ff467d5a0ba057371846d683a9.png";